import { Component } from 'react';
import GoFetch from '~/js/modules/fetch-wrapper';
import MainView from '~/js/views/general/components/liv-plus/MainView';
import DetailsView from '~/js/views/general/components/liv-plus/DetailsView';
import categoriesData from '~/js/views/general/components/liv-plus/data/categories';

const fetch = new GoFetch();

class LivPlusContainer extends Component {
    state = {
        eventsData: [],
        isEventsLoading: true
    }

    componentDidMount() {
        this.getData();
    }

    getData = () => {
        fetch.post('/events/getLivPlus/')
            .then((response) => {
                const eventNameObj = {};
                const eventsWhatShouldBeMerged = [
                    '2019 Sandals Reunion Week (April 22-26, 2019)',
                    '2018 Beaches Reunion Week (October 22-26, 2018)',
                    '2019 Beaches Reunion Week (October 21-25, 2019)',
                    '13th Annual Chairman\'s Golf Invitational (May 15-18, 2019)'
                ];
                const beachesEvents = [
                    'Big Summer Soccer',
                    'NAMASTAY AT BEACHES RESORTS'
                ];
                let { events } = response.data;

                events = events.filter((el) => {
                    if (eventNameObj.hasOwnProperty(el.eventName)) {
                        return false;
                    }

                    if (beachesEvents.includes(el.eventName)) {
                        el.resortInfo = 'All Beaches Resorts';
                    }

                    if (eventsWhatShouldBeMerged.includes(el.eventName)) {
                        if (el.eventName.indexOf('Sandals') !== -1) {
                            el.resortInfo = 'All Sandals Resorts';
                            el.rstCode = 'ALL';
                        } else if (el.eventName.indexOf('Golf Invitational') !== -1) {
                            el.resortInfo = 'Sandals Golf & Country Club';
                            el.rstCodes = ['BRP', 'SGO', 'BBO'];
                        } else {
                            el.resortInfo = 'All Beaches Resorts';
                            el.rstCode = 'ALL';
                        }

                        eventNameObj[el.eventName] = el;
                    }

                    return true;
                });

                this.setState((prevState) => ({
                    eventsData: [...prevState.eventsData, ...events],
                    isEventsLoading: false
                }));
            });
    }

    learMoreHandler = (event) => {
        this.prevTopScroll = window.scrollY;

        window.scrollTo(0, 0);

        this.setState({ eventDetails: event });
    }

    setQueryParams = (category) => {
        const state = { section: category };

        let uri = window.location.pathname;

        if (category) {
            uri = `?${$.param(state)}`;
        }

        window.history.pushState(state, null, uri);
    }

    getQueryParams = (name) => {
        const results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);

        return results && (results[1] || null);
    }

    tabHandler = (tab) => {
        if (tab.type === 'all') {
            this.setState({ tabChecked: null }, this.setQueryParams(null));
        } else {
            this.setState({ tabChecked: tab }, this.setQueryParams(tab.type));
        }
    }

    backClickedHandler = () => {
        this.setState({ eventDetails: null });
    }

    scrollToPrevItem = () => {
        this.prevTopScroll && window.scrollTo(0, this.prevTopScroll);
    }

    setDefaultSection = () => {
        const section = this.getQueryParams('section');

        if (section) {
            const currentCategory = categoriesData.find((el) => el.type === section);

            currentCategory && this.setState({ tabChecked: currentCategory });
        }
    }

    renderView = () => {
        const { eventsData, eventDetails, tabChecked, isEventsLoading } = this.state;

        let filtredEventsData = eventsData;

        if (tabChecked) {
            filtredEventsData = eventsData.filter((el) => el.groupName.toLowerCase() === tabChecked.type);
        }

        let view = (
            <MainView
                events={filtredEventsData}
                tabChecked={tabChecked}
                loading={isEventsLoading}
                tabHandler={this.tabHandler}
                learMoreHandler={this.learMoreHandler}
                initialTopScroll={this.scrollToPrevItem}
                setDefaultSection={this.setDefaultSection} />
        );

        if (eventDetails) {
            view = <DetailsView data={eventDetails} onBackClicked={this.backClickedHandler} />;
        }

        return view;
    }

    render() {
        return this.renderView();
    }
}

export default LivPlusContainer;
